<template>
  <div class="d-flex align-center justify-center flex-gap-8">
    <div>
      <span>{{ $t("quoteInfo.side") }}</span>
      <v-radio-group
        v-model="side"
        class="mt-0"
        row
        mandatory
        @change="onSideChange"
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio :label="$t('quoteInfo.buy').toUpperCase()" value="BUY">
        </v-radio>
        <v-radio :label="$t('quoteInfo.sell').toUpperCase()" value="SELL">
        </v-radio>
      </v-radio-group>
    </div>
    <div>
      <span>{{ $t("quoteInfo.commodities") }}</span>
      <v-select
        prepend-icon="mdi-sack"
        v-model="selectedCommodity"
        :items="commodities"
        @change="onCommodityChange"
        label="commodities"
        :disabled="loadingNewRfq || gridActive"
      ></v-select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["loadingNewRfq", "gridActive"],
  emits: ["side", "selectedCommodity"],
  data() {
    return {
      menu: false,
      side: undefined,
      selectedCommodity: "",
      commodities: ["Beans", "Coffee", "Corn", "Rice", "Soy", "Wheat"],
    };
  },
  methods: {
    onSideChange(val) {
      this.$emit("side", val);
    },
    onCommodityChange(val) {
      this.$emit("selectedCommodity", val);
    },
  },
};
</script>
